export interface CameraOpts {
  name?: string;
  h264?: string;
  mjpeg?: string;
  username?: string;
  password?: string;
}

export interface DataIn {
  cameras?: CameraOpts[],
  upstream?: string
}
